module.exports = __webpack_public_path__ + "static/src/content/images/shoals.0d27f44.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/shoals.png
// module id = Pg9H
// module chunks = 0